import { ConfirmModalConfig } from "@/models/ICommon"
import stores from "@/stores"

export function showConfirmModal(config: ConfirmModalConfig) {
  stores.CommonStore.setConfirmModalConfig(config)
}
